module.exports = __webpack_public_path__ + "img/2021_1_19_monster_hill.02d7faca.jpg";